import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    editIbanValue: '{bankName} · {iban}',
    labels: {
      amount: 'Expense incl. VAT',
      description: 'Description of expense',
      reseller: 'Seller',
      supportingDocument: 'Supporting document',
      vatRate: '{rate} % VAT',
    },
    submit: 'Submit request',
    submitSuccess: 'The refund submission has been sent successfully',
    title: 'Review your request',
    values: {
      amount: '{total}',
    },
  },
  fr: {
    cancel: 'Annuler',
    editIbanValue: '{bankName} · {iban}',
    labels: {
      amount: 'Montant de la dépense TTC',
      description: 'Description de la dépense',
      reseller: 'Vendeur',
      supportingDocument: 'Justificatif',
      vatRate: 'TVA {rate} %',
    },
    submit: 'Soumettre la demande',
    submitSuccess: 'La soumission de remboursement a été envoyée avec succès',
    title: 'Vérifiez votre demande',
    values: {
      amount: '{total} TTC',
    },
  },
} as const);

export default locales;
